import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import {ActivatedRoute} from '@angular/router';
import {CookieService} from 'ngx-cookie-service';
import {LayoutManagerService} from '../layout-manager.service';
import {ApiService, SignInResult} from '../api/api.service';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.css']
})
export class SignInComponent implements OnInit {

  formGroup: FormGroup;
  matcher = new LoginStateMatcher(this);
  signedIn = false;
  signInResponse: SignInResult;
  partner = false;
  loading = false;
  affiliato=false;
  affEmail: string = '';

  changesCheck(checkBox) {
    this.partner = checkBox.checked;
  }

  constructor(
    private formBuilder: FormBuilder,
    private api: ApiService,
    public layoutManager: LayoutManagerService,
    private cookieService: CookieService,
    private activatedRoute: ActivatedRoute
  ) {
    this.formGroup = formBuilder.group({
      name: [Validators.required],
      email: [Validators.required, Validators.email],
      password: [Validators.required, Validators.minLength(7)],
      password_check: [Validators.required, Validators.minLength(7)],
      fisc_code: [Validators.required, Validators.pattern('^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$')],
      indirizzo: [Validators.required],
      civico: [Validators.required],
      citta: [Validators.required],
      cap: [Validators.required, Validators.pattern('\\d{5}')]
    });

    window.scroll(0,0)

    this.formGroup.controls.name.setValue('');
    this.formGroup.controls.email.setValue('');
    this.formGroup.controls.password.setValue('');
    this.formGroup.controls.password_check.setValue('');
    this.formGroup.controls.fisc_code.setValue('');
    this.formGroup.controls.indirizzo.setValue('');
    this.formGroup.controls.civico.setValue('');
    this.formGroup.controls.citta.setValue('');
    this.formGroup.controls.cap.setValue('');
  }

  ngOnInit() {
    if(this.activatedRoute.snapshot.paramMap.get("affiliate")!= undefined && this.activatedRoute.snapshot.paramMap.get("affiliate")!= '') {
      const expiredDate = new Date();
      expiredDate.setDate( expiredDate.getDate() + 365 );
      this.cookieService.set('affiliate', btoa(this.activatedRoute.snapshot.paramMap.get("affiliate")), expiredDate);
      this.affiliato = true;
    }
    this.affEmail = this.cookieService.get('affiliate');
    if (this.affEmail!=undefined && this.affEmail!='')
      this.affiliato = true;
  }

  signInClick() {
    let valid = this.formGroup.get('password').value === this.formGroup.get('password_check').value;
    valid = valid && this.formGroup.valid;
    if (valid) {
      this.loading = true;
      this.api.signIn(this.formGroup.controls.name.value, btoa(this.formGroup.controls.email.value),
        btoa(this.formGroup.controls.password.value),
        btoa(this.formGroup.controls.indirizzo.value), btoa(this.formGroup.controls.civico.value),
        btoa(this.formGroup.controls.citta.value), btoa(this.formGroup.controls.cap.value),
        btoa(this.formGroup.controls.fisc_code.value),
        this.partner, this.affiliato, this.affEmail).subscribe(response => {
        this.signedIn = true;
        this.loading = false;
        this.signInResponse = response;
      })
    }
  }
}
/** Error when invalid control is dirty, touched, or submitted. */
export class LoginStateMatcher implements ErrorStateMatcher {

  constructor(private parentClass) {

  }

  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const samePassword = this.parentClass.formGroup.get('password').value !== this.parentClass.formGroup.get('password_check').value;
    return !!(control && control.invalid
      && (control.dirty || control.touched)) || samePassword;
  }
}
